import { Button, Form, Input, message, Select, Checkbox, Popconfirm, Row, Col, InputNumber } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { CloseOutlined } from "@ant-design/icons";
import { datPeriodVids, tariffKinds } from "../../extensions/helper";
import { isMobile } from "../../extensions/design";

const defaultItem = { vid: 1, srokVid: 31, srok: 1, price: 0, active: true, default: false };

const LicenseTariff = ({ id, onClose }) => {
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`Tariff/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      setItem({ ...defaultItem });
      form.setFieldsValue(defaultItem);
    }
  };

  useEffect(getData, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const onValuesChange = (changedValues, allValues) => {
    setItem({ ...item, ...changedValues });
  };

  // Функции для работы с битовой маской permissions
  const isBitSet = (bit) => {
    const mask = item.permissions || 0;
    return (mask & (1 << bit)) !== 0;
  };

  const toggleBit = (bit) => {
    const mask = item.permissions || 0;
    const newMask = mask ^ (1 << bit);
    setItem({ ...item, permissions: newMask });
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      serverFetch("Tariff", { method: id ? "PUT" : "POST", bodyData: item })
        .then(() => onClose(true))
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const onDelete = () => {
    setLoading(true);
    serverFetch(`Tariff/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return !isMobile ? (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={e => e.target === e.currentTarget && onClose(false)}>
        <div className="sport-modal-content" style={{ width: 500 }} onMouseDown={e => e.stopPropagation()}>
          <div className="sport-section-title">
            <span>{id ? "Тариф" : "Новый тариф"}</span>
            <CloseOutlined className="sport-section-title-close" onClick={() => onClose(false)} />
          </div>
          <Form form={form} layout="vertical" onValuesChange={onValuesChange}>
            <Form.Item name="name" label="Название" rules={[{ required: true, message: "Введите название тарифа" }]}>
              <Input placeholder="Название тарифа" />
            </Form.Item>
            <Form.Item name="vid" label="Вид тарифа" rules={[{ required: true, message: "Выберите вид тарифа" }]}>
              <Select options={tariffKinds} />
            </Form.Item>
            <Form.Item name="srokVid" label="Единица измерения срока" rules={[{ required: true, message: "Выберите единицу измерения" }]} >
              <Select options={datPeriodVids} />
            </Form.Item>
            <Form.Item name="srok" label="Срок (количество)" rules={[{ required: true, message: "Введите срок" }]}>
              <Input type="number" min={1} />
            </Form.Item>
            <Form.Item name="price" label="Цена" rules={[{ required: true, message: "Введите цену" }]}>
              <Input type="number" min={0} step={0.01} />
            </Form.Item>
            <Form.Item name="active" valuePropName="checked"><Checkbox>Активен</Checkbox></Form.Item>
            <Form.Item name="default" valuePropName="checked"><Checkbox>По умолчанию</Checkbox></Form.Item>
            
            <Form.Item label="Активные модули">
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                <Checkbox checked={isBitSet(0)} onChange={() => toggleBit(0)}>
                  Онлайн виджет
                </Checkbox>
                <Checkbox checked={isBitSet(1)} onChange={() => toggleBit(1)}>
                  Сообщения
                </Checkbox>
                <Checkbox checked={isBitSet(2)} onChange={() => toggleBit(2)}>
                  СКД
                </Checkbox>
              </div>
            </Form.Item>

            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 16 }}>
              <div>
                {id && (
                  <Popconfirm title="Удалить тариф?" description="Это действие нельзя отменить" onConfirm={onDelete} okText="Да" cancelText="Нет">
                    <Button danger loading={loading}>Удалить</Button>
                  </Popconfirm>
                )}
              </div>
              <div style={{ display: 'flex', gap: 8 }}>
                <Button onClick={() => onClose(false)}>Отмена</Button>
                <Button type="primary" onClick={onSave} loading={loading}>Сохранить</Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  ) : (
  <div className="sport-modal">
    <div className="sport-modal-overlay">
      <div className="sport-modal-content">
        <div className="sport-modal-title">
          <span>{id ? "Тариф" : "Новый тариф"}</span>
          <CloseOutlined onClick={() => onClose(false)} className="sport-section-title-close client-close-outlined-button-style"/>
        </div>
        <Form form={form} layout="inline" loading={loading} colon={false} onValuesChange={onValuesChange}  labelCol={{ xs: 6 }} wrapperCol={{ xs: 18 }}>
          <Form.Item name="name" label="Назв." rules={[{ required: true, message: "Введите название тарифа" }]} className="records-form-item-mobile">
            <Input placeholder="Название тарифа" className="records-form-item-mobile"/>
          </Form.Item>
          <Form.Item name="vid" label="Вид" rules={[{ required: true, message: "Выберите вид тарифа" }]} className="record-form-item-with-margin-top-mobile">
            <Select options={tariffKinds} className="records-form-item-mobile"/>
          </Form.Item>
          <Form.Item name="srokVid" label="Ед.изм." rules={[{ required: true, message: "Выберите единицу измерения" }]} className="record-form-item-with-margin-top-mobile">
            <Select options={datPeriodVids} className="records-form-item-mobile"/>
          </Form.Item>
          <Form.Item name="srok" label="Срок (кол.)" rules={[{ required: true, message: "Введите срок" }]} className="record-form-item-with-margin-top-mobile">
            <InputNumber min={1} className="records-form-item-mobile"/>
          </Form.Item>
          <Form.Item name="price" label="Цена" rules={[{ required: true, message: "Введите цену" }]} className="record-form-item-with-margin-top-mobile">
            <InputNumber min={0} step={0.01} className="records-form-item-mobile"/>
          </Form.Item>
          <Form.Item label="Акт. мод." className="records-form-item-mobile">
            <Row>
              <Col span={10}>
                <Checkbox checked={isBitSet(0)} onChange={() => toggleBit(0)} style={{fontSize:"14px", whiteSpace:"nowrap"}}> Онл. видж. </Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox style={{fontSize:"14px"}} checked={isBitSet(1)} onChange={() => toggleBit(1)}> Сообщ. </Checkbox>
              </Col>
              <Col span={6}>
                <Checkbox style={{fontSize:"14px"}} checked={isBitSet(2)} onChange={() => toggleBit(2)}> СКД </Checkbox>
              </Col>
            </Row>
          </Form.Item>
          <Row style={{marginLeft:"4px"}}>
            <Col span={12}>
              <Form.Item name="active" valuePropName="checked"><Checkbox style={{fontSize:"14px"}}>Активен</Checkbox></Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item name="default" valuePropName="checked"><Checkbox style={{fontSize:"14px", whiteSpace:"nowrap"}}>По умолчанию</Checkbox></Form.Item>
            </Col>
          </Row>
          <div className="license-popconfirm-button">
            {!!id && (
              <Popconfirm title="Удалить тариф?" description="Это действие нельзя отменить" onConfirm={onDelete} okText="Да" cancelText="Нет"
                placement="top" getPopupContainer={(trigger) => trigger.closest('.license-popconfirm-button')} overlayClassName="centered-popconfirm">
                <Button danger loading={loading} style={{width: "100%", flex: 1}}>Удалить</Button>
              </Popconfirm>
            )}
            <Button type="primary" onClick={onSave} loading={loading} style={{flex: 1}}>Сохранить</Button>
          </div>
        </Form>
      </div>
    </div>
  </div>);
};

export default LicenseTariff;